module.exports = __webpack_public_path__ + "img/goods-2.20da2589.png";